'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dValidation$002dPage from "./presto.-Validation-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_ValidationPage$() {
}
export { $c_Lpresto_ValidationPage$ as $c_Lpresto_ValidationPage$ };
$p = $c_Lpresto_ValidationPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ValidationPage$;
/** @constructor */
function $h_Lpresto_ValidationPage$() {
}
export { $h_Lpresto_ValidationPage$ as $h_Lpresto_ValidationPage$ };
$h_Lpresto_ValidationPage$.prototype = $p;
$p.l = (function() {
  return "ValidationPage";
});
$p.cGd = (function(x$0) {
  return new $j_presto$002e$002dValidation$002dPage.$c_Lpresto_ValidationPage(x$0.j(0));
});
var $d_Lpresto_ValidationPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ValidationPage$, "presto.ValidationPage$", ({
  UW: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_ValidationPage$ as $d_Lpresto_ValidationPage$ };
var $n_Lpresto_ValidationPage$;
function $m_Lpresto_ValidationPage$() {
  if ((!$n_Lpresto_ValidationPage$)) {
    $n_Lpresto_ValidationPage$ = new $c_Lpresto_ValidationPage$();
  }
  return $n_Lpresto_ValidationPage$;
}
export { $m_Lpresto_ValidationPage$ as $m_Lpresto_ValidationPage$ };
//# sourceMappingURL=presto.-Validation-Page$.js.map
